import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, numberAttribute } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ICoordinatesModel } from '../share/interfaces';

@Injectable({
  providedIn: 'root'
})
export class GpzxService {

  constructor(private httpClient: HttpClient) { }

getElevation(lat: number, lng: number): Observable<number> {
  const url = 'https://api.gpxz.io/v1/elevation/points';
  const headers = new HttpHeaders({
    'x-api-key': environment.gpxz.apiKey,
    'Content-Type': 'application/json'
  });
  const body = {
    latlons: `${lat},${lng}`
  };

  return this.httpClient.post<any>(url, body, { headers })
    .pipe(
      map(response => {
        if (response && response.results && response.results.length > 0) {
          return response.results[0].elevation;
        } else {
          throw new Error('Elevation data not found.');
        }
      }),
      catchError(error => {
        console.error('Error fetching elevation data:', error);
        return throwError('Özel Konum Bilgisi Bulunamadı');
      })
    );
}


getUserLocation(): Observable<ICoordinatesModel> {
  return new Observable<ICoordinatesModel>((observer) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          this.getElevation(lat, lng).subscribe(
            (elevation) => {
              observer.next({
                latitude: lat,
                longitude: lng,
                elevation: elevation
              } as ICoordinatesModel);
              observer.complete();
            },
            (error) => {
              observer.error('Error fetching elevation: ' + error);
            }
          );
        },
        (error) => {
          observer.error('Error getting location: ' + error.message);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      );
    } else {
      observer.error('Geolocation not supported by this browser.');
    }
  });
}
}
